// 借款功能（英）
module.exports = {
    top: {
        name1: 'yinwe'
    }
}